import React, { Children } from "react";
import { GridSize, styled } from "@mui/material";
import Grid from "@mui/material/Grid";
const StyledRow = styled(Grid)`
  margin: 12px 0;
`;

const InputContainer = styled(Grid)`
  max-width: 600px;
  align-items: center;
  spacing: 8px;
  justify-content: flex-start;
`;

const ChildItem = styled(Grid)``;

interface Props {
  children: (React.ReactElement | "" | undefined)[];
}

const threeColumns: GridSize[] = [2, 3, 7];
const FormikFormRow = ({ children }: Props) => {
  return (
    <StyledRow container size={{ md: 8, xs: 12 }} alignItems="center">
      <InputContainer container>
        {Children.map(children, (child, index) => {
          return (
            <ChildItem size={{ xs: threeColumns[index] }}>{child}</ChildItem>
          );
        })}
      </InputContainer>
    </StyledRow>
  );
};

export default FormikFormRow;
